<template>
  <div class="container-fluid my-4">
    <!-- Toast -->
    <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
      <div class="toast show align-items-center text-white" :class="tipoToast === 'success' ? 'bg-success' : 'bg-danger'">
        <div class="d-flex">
          <div class="toast-body">{{ mensajeToast }}</div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="mostrarToast = false"></button>
        </div>
      </div>
    </div>

    <div class="card shadow-sm p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="fw-semibold text-primary mb-0">Pagos por Crédito</h4>
        <span class="badge bg-warning text-dark fs-6">
          {{ creditosPendientes }} pendiente(s)
        </span>
      </div>

      <!-- Filtros -->
      <div class="row g-2 mb-4 align-items-end">
        <div class="col-md-3">
          <label class="form-label small text-muted mb-1">Estado</label>
          <select v-model="filtroEstado" class="form-select form-select-sm">
            <option value="">Todos</option>
            <option value="0">Pendiente</option>
            <option value="1">Pagado</option>
            <option value="2">Vencido</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label small text-muted mb-1">Módulo</label>
          <select v-model="filtroModulo" class="form-select form-select-sm">
            <option value="">Todos</option>
            <option value="restaurante">Restaurante</option>
            <option value="hotel">Hotel</option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label small text-muted mb-1">Fecha inicio</label>
          <input type="date" v-model="filtroFechaInicio" class="form-control form-control-sm" />
        </div>
        <div class="col-md-2">
          <label class="form-label small text-muted mb-1">Fecha fin</label>
          <input type="date" v-model="filtroFechaFin" class="form-control form-control-sm" />
        </div>
        <div class="col-md-2">
          <button class="btn btn-primary btn-sm w-100" @click="cargarCreditos" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
            Filtrar
          </button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered table-hover align-middle text-center">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Módulo</th>
              <th>Cliente</th>
              <th>NIT</th>
              <th>Descripción</th>
              <th>Monto</th>
              <th>Fecha Registro</th>
              <th>Fecha Vencimiento</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="10" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
              </td>
            </tr>
            <tr v-else-if="creditos.length === 0">
              <td colspan="10" class="text-muted py-4">No hay registros.</td>
            </tr>
            <tr v-for="c in creditos" :key="c.IdPagoCredito" :class="{ 'table-danger': c.Estado === 2, 'table-success': c.Estado === 1 }">
              <td>{{ c.IdPagoCredito }}</td>
              <td>
                <span class="badge" :class="c.Modulo === 'restaurante' ? 'bg-info' : 'bg-primary'">
                  {{ c.Modulo }}
                </span>
              </td>
              <td>{{ c.ReceptorNombre || 'N/A' }}</td>
              <td>{{ c.ReceptorNIT || 'CF' }}</td>
              <td class="text-start">{{ c.Descripcion || '-' }}</td>
              <td class="fw-bold">Q{{ parseFloat(c.Monto).toFixed(2) }}</td>
              <td>{{ formatearFecha(c.FechaRegistro) }}</td>
              <td :class="{ 'text-danger fw-bold': c.Estado === 2 }">
                {{ c.FechaVencimiento }}
              </td>
              <td>
                <span class="badge" :class="badgeEstado(c.Estado)">
                  {{ labelEstado(c.Estado) }}
                </span>
              </td>
              <td>
                <div class="d-flex gap-1 justify-content-center flex-wrap">
                  <button
                    v-if="c.Estado === 0"
                    class="btn btn-sm btn-outline-secondary"
                    @click="abrirEditar(c)"
                    title="Editar fecha de vencimiento"
                  >
                    Editar
                  </button>
                  <button
                    v-if="c.Estado === 0 || c.Estado === 2"
                    class="btn btn-sm btn-success"
                    @click="abrirCobrar(c)"
                  >
                    Cobrar
                  </button>
                  <span v-if="c.Estado === 1" class="text-muted small">
                    Cobrado {{ formatearFecha(c.FechaPago) }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Editar Vencimiento -->
    <div v-if="mostrarModalEditar" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Fecha de Vencimiento</h5>
            <button class="btn-close" @click="cerrarEditar"></button>
          </div>
          <div class="modal-body">
            <p class="text-muted small">Crédito #{{ editandoCredito?.IdPagoCredito }} — Q{{ parseFloat(editandoCredito?.Monto || 0).toFixed(2) }}</p>
            <label class="form-label fw-semibold">Nueva Fecha de Vencimiento</label>
            <input type="date" v-model="nuevaFechaVencimiento" class="form-control" :min="fechaMinima" />
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarEditar" :disabled="cargandoEditar">Cancelar</button>
            <button class="btn btn-primary" @click="guardarEditar" :disabled="cargandoEditar || !nuevaFechaVencimiento">
              <span v-if="cargandoEditar" class="spinner-border spinner-border-sm me-1"></span>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Cobrar -->
    <div v-if="mostrarModalCobrar" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-success text-white">
            <h5 class="modal-title">💳 Cobrar Crédito</h5>
            <button class="btn-close btn-close-white" @click="cerrarCobrar"></button>
          </div>
          <div class="modal-body">
            <!-- Resumen -->
            <div class="alert alert-info mb-3">
              <strong>Cliente:</strong> {{ cobrandoCredito?.ReceptorNombre || 'N/A' }}<br />
              <strong>Monto a cobrar:</strong> Q{{ parseFloat(cobrandoCredito?.Monto || 0).toFixed(2) }}<br />
              <strong>Descripción:</strong> {{ cobrandoCredito?.Descripcion || '-' }}
            </div>

            <!-- Factura existente -->
            <div v-if="cobrandoCredito?.facturaFel" class="alert alert-success mb-3">
              <strong>✓ Factura emitida:</strong> {{ cobrandoCredito.facturaFel.serie }}-{{ cobrandoCredito.facturaFel.numero }}
              <button
                class="btn btn-sm btn-outline-success ms-2"
                @click="reimprimirFactura"
              >
                🖨️ Reimprimir
              </button>
            </div>
            <div v-else class="alert alert-warning mb-3">
              <strong>⚠️ Factura:</strong> Este crédito no tiene factura.
              <div class="mt-2">
                <div class="form-check">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="sin-factura"
                    v-model="generarFactura"
                    :value="false"
                  />
                  <label class="form-check-label" for="sin-factura">
                    Cobrar sin factura
                  </label>
                </div>
                <div class="form-check">
                  <input
                    type="radio"
                    class="form-check-input"
                    id="con-factura"
                    v-model="generarFactura"
                    :value="true"
                  />
                  <label class="form-check-label" for="con-factura">
                    Generar factura al cobrar
                  </label>
                </div>
              </div>
            </div>

            <!-- Datos de factura (si se va a generar) -->
            <div v-if="generarFactura && !cobrandoCredito?.facturaFel" class="border rounded p-3 mb-3">
              <h6 class="mb-3">Datos del Receptor (Factura)</h6>
              <div class="mb-2">
                <label class="form-label small">NIT</label>
                <div class="input-group">
                  <input
                    v-model="receptorNIT"
                    @input="nitVerificado = false"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="ej: CF o 7654321-0"
                  />
                  <button
                    class="btn btn-outline-primary btn-sm"
                    type="button"
                    @click="verificarNitManual"
                    :disabled="cargandoVerificacionNit || !receptorNIT.trim()"
                  >
                    <span v-if="cargandoVerificacionNit" class="spinner-border spinner-border-sm"></span>
                    <span v-else>Verificar</span>
                  </button>
                </div>
                <small v-if="nitVerificado" class="text-success">
                  <i class="bi bi-check-circle-fill me-1"></i>NIT verificado
                </small>
                <small v-else-if="receptorNIT.trim()" class="text-warning">
                  <i class="bi bi-exclamation-triangle-fill me-1"></i>Pendiente de verificar
                </small>
              </div>
              <div class="mb-2">
                <label class="form-label small">Nombre</label>
                <input
                  v-model="receptorNombre"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Nombre o razón social"
                />
              </div>
              <div class="mb-0">
                <label class="form-label small">Dirección (opcional)</label>
                <input
                  v-model="receptorDireccion"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Dirección"
                />
              </div>
            </div>

            <!-- Método de pago -->
            <div class="mb-3">
              <label class="form-label fw-semibold">Método de Pago</label>
              <select v-model="metodoCobro" @change="onMetodoCambio" class="form-select">
                <option :value="null" disabled>Seleccione método</option>
                <option v-for="m in metodosPago" :key="m.IdMetodoPago" :value="m.IdMetodoPago">
                  {{ m.Metodo }}
                </option>
              </select>
            </div>

            <!-- Cuenta bancaria si es depósito/transferencia -->
            <div v-if="requiereCuentaBancaria" class="mb-3">
              <label class="form-label fw-semibold">Cuenta Bancaria</label>
              <select v-model="cuentaBancariaSeleccionada" class="form-select">
                <option :value="null" disabled>Seleccione cuenta</option>
                <option v-for="c in cuentasBancarias" :key="c.IdCuentaBancaria" :value="c.IdCuentaBancaria">
                  {{ c.Banco }} - {{ c.NombreCuenta }} ({{ c.NumeroCuenta }})
                </option>
              </select>
            </div>

            <!-- Número de referencia -->
            <div v-if="requiereReferencia" class="mb-3">
              <label class="form-label fw-semibold">Número de Referencia</label>
              <input v-model="numeroReferencia" type="text" class="form-control" placeholder="Referencia de transacción" />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="cerrarCobrar" :disabled="cargandoCobrar">Cancelar</button>
            <button
              class="btn btn-success"
              @click="confirmarCobro"
              :disabled="cargandoCobrar || !metodoCobro || (requiereCuentaBancaria && !cuentaBancariaSeleccionada) || (generarFactura && !cobrandoCredito?.facturaFel && !nitVerificado)"
            >
              <span v-if="cargandoCobrar" class="spinner-border spinner-border-sm me-1"></span>
              Confirmar Cobro
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/config/axios'
import { API_URL } from '@/config/config'

export default {
  name: 'PagosPorCredito',
  data() {
    return {
      creditos: [],
      loading: false,
      filtroEstado: '0',
      filtroModulo: '',
      filtroFechaInicio: '',
      filtroFechaFin: '',
      mostrarToast: false,
      mensajeToast: '',
      tipoToast: 'success',
      // Editar vencimiento
      mostrarModalEditar: false,
      editandoCredito: null,
      nuevaFechaVencimiento: '',
      cargandoEditar: false,
      // Cobrar
      mostrarModalCobrar: false,
      cobrandoCredito: null,
      metodosPago: [],
      metodoCobro: null,
      cargandoCobrar: false,
      cuentasBancarias: [],
      cuentaBancariaSeleccionada: null,
      numeroReferencia: '',
      // Datos de factura
      generarFactura: false,
      receptorNIT: '',
      receptorNombre: '',
      receptorDireccion: '',
      nitVerificado: false,
      cargandoVerificacionNit: false,
    }
  },
  computed: {
    creditosPendientes() {
      return this.creditos.filter(c => c.Estado === 0).length
    },
    fechaMinima() {
      const d = new Date()
      d.setDate(d.getDate() + 1)
      return d.toISOString().split('T')[0]
    },
    requiereCuentaBancaria() {
      const metodo = this.metodosPago.find(m => m.IdMetodoPago === this.metodoCobro)
      return !!metodo && /transferencia|depósito|deposito/i.test(metodo.Metodo)
    },
    requiereReferencia() {
      const metodo = this.metodosPago.find(m => m.IdMetodoPago === this.metodoCobro)
      return !!metodo && /transferencia|depósito|deposito|cheque|tarjeta/i.test(metodo.Metodo)
    },
  },
  async mounted() {
    await this.cargarCreditos()
    await Promise.all([this.cargarMetodosPago(), this.cargarCuentasBancarias()])
  },
  methods: {
    async cargarCreditos() {
      this.loading = true
      try {
        const params = {}
        if (this.filtroEstado !== '') params.estado = this.filtroEstado
        if (this.filtroModulo) params.modulo = this.filtroModulo
        if (this.filtroFechaInicio) params.fecha_inicio = this.filtroFechaInicio
        if (this.filtroFechaFin) params.fecha_fin = this.filtroFechaFin
        const { data } = await axios.get(`${API_URL}/pagos-credito`, { params })
        this.creditos = Array.isArray(data.data) ? data.data : []
      } catch {
        this.toast('Error al cargar los créditos', 'danger')
      } finally {
        this.loading = false
      }
    },
    async cargarMetodosPago() {
      try {
        // Cargar todos los métodos de pago
        const { data } = await axios.get(`${API_URL}/metodos-pago`)
        this.metodosPago = Array.isArray(data) ? data : []
      } catch {
        this.metodosPago = []
      }
    },
    async cargarCuentasBancarias() {
      try {
        const { data } = await axios.get(`${API_URL}/cuentas-bancarias`)
        this.cuentasBancarias = Array.isArray(data) ? data : []
      } catch {
        this.cuentasBancarias = []
      }
    },
    abrirEditar(credito) {
      this.editandoCredito = credito
      this.nuevaFechaVencimiento = credito.FechaVencimiento
      this.mostrarModalEditar = true
    },
    cerrarEditar() {
      this.mostrarModalEditar = false
      this.editandoCredito = null
      this.nuevaFechaVencimiento = ''
    },
    async guardarEditar() {
      try {
        this.cargandoEditar = true
        const { data } = await axios.put(
          `${API_URL}/pagos-credito/${this.editandoCredito.IdPagoCredito}`,
          { FechaVencimiento: this.nuevaFechaVencimiento }
        )
        this.toast(data.message || 'Fecha actualizada correctamente', 'success')
        this.cerrarEditar()
        await this.cargarCreditos()
      } catch (err) {
        this.toast(err.response?.data?.message || 'Error al actualizar', 'danger')
      } finally {
        this.cargandoEditar = false
      }
    },
    abrirCobrar(credito) {
      this.cobrandoCredito = credito
      this.metodoCobro = null
      this.cuentaBancariaSeleccionada = null
      this.numeroReferencia = ''
      this.generarFactura = false
      this.receptorNIT = credito.ReceptorNIT || ''
      this.receptorNombre = credito.ReceptorNombre || ''
      this.receptorDireccion = credito.ReceptorDireccion || ''
      this.nitVerificado = false
      this.mostrarModalCobrar = true
    },
    cerrarCobrar() {
      this.mostrarModalCobrar = false
      this.cobrandoCredito = null
      this.metodoCobro = null
      this.cuentaBancariaSeleccionada = null
      this.numeroReferencia = ''
      this.generarFactura = false
      this.receptorNIT = ''
      this.receptorNombre = ''
      this.receptorDireccion = ''
      this.nitVerificado = false
    },
    onMetodoCambio() {
      this.cuentaBancariaSeleccionada = null
      this.numeroReferencia = ''
    },
    reimprimirFactura() {
      if (this.cobrandoCredito?.facturaFel?.pdf_url) {
        window.open(this.cobrandoCredito.facturaFel.pdf_url, '_blank')
      } else {
        this.toast('No hay factura disponible para reimprimir', 'warning')
      }
    },
    async confirmarCobro() {
      if (!this.metodoCobro) return
      try {
        this.cargandoCobrar = true
        const idEmpleado = this.$store.state.user?.IdEmpleado
        const payload = {
          IdMetodoPago:    this.metodoCobro,
          IdEmpleadoCobro: idEmpleado,
        }

        if (this.generarFactura && !this.cobrandoCredito?.facturaFel) {
          payload.generar_factura = true
          payload.receptor_nit = this.receptorNIT || 'CF'
          payload.receptor_nombre = this.receptorNombre || 'Consumidor Final'
          payload.receptor_direccion = this.receptorDireccion || ''
        }

        const { data } = await axios.post(
          `${API_URL}/pagos-credito/${this.cobrandoCredito.IdPagoCredito}/cobrar`,
          payload
        )
        this.toast(data.message || 'Crédito cobrado correctamente', 'success')
        this.cerrarCobrar()
        await this.cargarCreditos()
      } catch (err) {
        this.toast(err.response?.data?.message || 'Error al cobrar el crédito', 'danger')
      } finally {
        this.cargandoCobrar = false
      }
    },
    async verificarNitManual() {
      if (!this.receptorNIT.trim()) return
      this.cargandoVerificacionNit = true
      this.nitVerificado = false
      try {
        const { data: nitInfo } = await axios.get(
          `${API_URL}/facturas-fel/verificar-nit/${encodeURIComponent(this.receptorNIT.trim())}`
        )
        if (nitInfo.valido) {
          this.nitVerificado = true
          if (nitInfo.nombre) this.receptorNombre = nitInfo.nombre
          this.toast('NIT verificado correctamente', 'success')
        } else {
          this.toast('NIT no válido o no encontrado', 'danger')
        }
      } catch {
        this.toast('Error al verificar el NIT', 'danger')
      } finally {
        this.cargandoVerificacionNit = false
      }
    },
    badgeEstado(estado) {
      return { 0: 'bg-warning text-dark', 1: 'bg-success', 2: 'bg-danger' }[estado] ?? 'bg-secondary'
    },
    labelEstado(estado) {
      return { 0: 'Pendiente', 1: 'Pagado', 2: 'Vencido' }[estado] ?? 'Desconocido'
    },
    formatearFecha(fecha) {
      if (!fecha) return '-'
      return new Date(fecha).toLocaleDateString('es-GT')
    },
    toast(msg, tipo = 'success') {
      this.mensajeToast = msg
      this.tipoToast = tipo
      this.mostrarToast = true
      setTimeout(() => { this.mostrarToast = false }, 3000)
    },
  },
}
</script>
